/**
 * Defines the footer portion of the Basic Illustration
 */
export class Footer {
  /**
   * Get the HTML content for the Basic Illustration Footer
   *
   * @param last defines whether this footer is for the last page, defaults to `false`
   * @returns a string containing the HTML content of the footer
   */
  static getFooterBody(last: boolean = false): string {
    return (
      `
        <div id="pageFooter" class="page-wrapper">
            <hr class="footerbreak"/>
            <table id="footer-table" class="full-width" cellspacing=0 cellpadding=0>
                <tr>
                    <td align="left">
                        <p class="p-footer">
                            <span class="p-footer-bold">Prepared for:</span>
                            {{ClientFirstName}} {{ClientLastName}} ({{ClientGender}}, {{ClientAge}}, {{UnderwritingClassForFooter}})
                        </p>
                        <p class="p-footer">
                            <span class="p-footer-bold">Presented by:</span>
                            {{AgentFirstName}} {{AgentLastName}}
                        </p>
                        <p class="p-footer">
                            <span class="p-footer-bold">Prepared on:</span>
                            {{CurrentDate}}
                        </p>
                    </td>
                    <td align="right" colspan="2">
                        <p class="p-footer">
                            <span class="p-footer-bold">MEC Limit:</span>
                            {{MECLimit}}
                        </p>
                        <p class="p-footer">
                            <span class="p-footer-bold">Version:</span>
                            {{Version}} ({{State}})
                        </p>
                    </td>
                </tr>
            </table>
        ` +
      (!last
        ? `
            <div class="pagenumbers">
                <p class="p-pagenumbers">Page {{page}} of {{pages}}</p>
            </div>
        `
        : `
            <div>
                <table class="full-width" cellspacing=0 cellpadding=0>
                    <tr>
                        <td colspan=5 align="center"><p class="p-pagenumbers">
                            Massachusetts Mutual Life Insurance Company, Springfield, MA 01111-0001
                        </p></td>
                        <td><p class="p-pagenumbers">
                            Page {{page}} of {{pages}}
                        </p></td>
                    </tr>
                </table>
            </div>
        `) +
      `
        </div>
        `
    );
  }

  /**
   * Get the CSS styling for the Basic Illustration footer
   *
   * @returns a string containg the CSS content for styling the footer
   */
  static getFooterStyle(): string {
    return `
        #pageFooter {
           font-size:8px;
           line-height:8px;
           margin:0px;
           padding:0px;
           position: absolute;
           bottom: 0;
           margin-bottom: -10px;
       }

        hr.footerbreak {
            border: none;
            background-color: #000;
            color: #000;
            height: 1px;
            margin-bottom:2px;
        }
        
        .p-footer {
            font-family: 'Times New Roman';
            font-size: 8px;
            margin-top: 0px;
            margin-bottom: 0px;
            line-height: 8px;
        }
        
        .p-footer-bold {
            font-family: 'Times New Roman';
            font-weight: bold;
        }
        
        .pagenumbers {
            padding-left: 500px;
        }

        .p-pagenumbers {
            font-family: 'Arial Narrow';
            font-size: 8px;
            font-weight: bold;
        }
        `;
  }
}
